<div class="login-page">
    <div class="container">
        <div class="login-box mat-elevation-z8">
            <h1>CMG Studios</h1>
            <p>Log Management System</p>
            <button mat-raised-button class="login-button" (click)="onLoginClick()">Login With Discord</button>
        </div>
    </div>
</div>